//Settings Servies
import AxiosInstance from "../Utils/axios/axiosConfig";

export const getMachineGradeSelect = async (value) => {
  const response = await AxiosInstance.get("/settings/");
  return response;
};

export const getMachineGradeSelectForConfig = async (value) => {
  const response = await AxiosInstance.get("/crud/settings/");
  return response;
};

export const getAllGrades = async (status) => {
  const response = status
    ? await AxiosInstance.get(`/settings/?grades&${status}`)
    : await AxiosInstance.get("/settings/?grades");
  return handler(response);
};

export const getAllGradesWithQualities = async (status) => {
  const response = await AxiosInstance.get(`/settings/?${status}`)
  return handler(response);
};

export const getAllGradesForConfig = async (status) => {
  const response = status
    ? await AxiosInstance.get(`/crud/settings/?grades&${status}`)
    : await AxiosInstance.get("/crud/settings/?grades");
  return handler(response);
};

export const getGradeQualities = async (grade, status) => {
  const response = status
    ? await AxiosInstance.get(`/settings/?qualities&grade=${grade}&${status}`)
    : await AxiosInstance.get(`/settings/?qualities&grade=${grade}`);
  return handler(response);
};

export const getGradeQualitiesForConfig = async (grade, status) => {
  const response = status
    ? await AxiosInstance.get(`/crud/settings/?qualities&grade=${grade}&${status}`)
    : await AxiosInstance.get(`/crud/settings/?qualities&grade=${grade}`);
  return handler(response);
};

export const setOrderType = async (body) => {
  const response = await AxiosInstance.put("/crud/settings/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
  //return handler(response);
};

export const addNewGrade = async (body) => {
  const response = await AxiosInstance.post("/crud/settings/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const deleteGrade = async (name) => {
  //const response = await AxiosInstance.delete("/settings/", body);
  const response = await AxiosInstance.delete(`/crud/settings/?grade=${name}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const deleteQuality = async (grade, quality) => {
  const response = await AxiosInstance.delete(
    `/crud/settings/?grade=${grade}&quality=${quality}`
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

const handler = async (response) => {
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const getUploadFormats = async () => {
  const response = await AxiosInstance.get("/settings/upload_format/?separate");
  return response;
};
export const getAllUploadFormats = async () => {
  const response = await AxiosInstance.get("/settings/upload_format/");
  return response;
};

export const defaultUploadFormat = async (body) => {
  const response = await AxiosInstance.put("/settings/upload_format/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const getGradeProductParameter = async (grade) => {
  const response = await AxiosInstance.get(`/settings/?product&grade=${grade}`);
  return handler(response);
};

export const getReelCoreValues = async () => {
  const response = await AxiosInstance.get(`/orders/settings/`);
  return handler(response);
};

export const addReelCoreValues = async (body) => {
  const response = await AxiosInstance.post("/orders/settings/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const updateCoreValue = async (body,core,unit) => {
  const response = await AxiosInstance.put(`/orders/settings/?core_id=${core}&unit=${unit}`, body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const updateReelValue = async (body,reel,unit) => {
  const response = await AxiosInstance.put(`/orders/settings/?reel_od=${reel}&unit=${unit}`, body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const deleteReelValue = async (reel, unit) => {
  const response = await AxiosInstance.delete(`/orders/settings/?reel_od=${reel}&unit=${unit}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const deleteCoreValue = async (core, unit) => {
  const response = await AxiosInstance.delete(`/orders/settings/?core_id=${core}&unit=${unit}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const updateSheetSpecs = async (body) => {
  const response = await AxiosInstance.put(`/orders/settings/?sheet_order`, body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response.message);
  }
};

export const updateOrderTolerance = async (body) => {
   const response = await AxiosInstance.put(`/orders/settings/?tolerances`,body);
   if (!response.data.error) {
     return response.data;
   } else {
      return Promise.reject(response.message);
    }
  };

  export const getOrderTolerances = async () => {
    const response = await AxiosInstance.get("/orders/settings/?tolerances");
    return response;
  };

  export const getJobCardSerialNumberParam = async () => {
    const response = await AxiosInstance.get("/advanced/settings/");
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

  export const updateJobCardSerialNumberParam  = async (body) => {
    const response = await AxiosInstance.put(`/advanced/settings/?jobcard_code_config`,body);
    if (!response.data.error) {
      return response.data;
    } else {
       return Promise.reject(response.message);
     }
   };

  export const updateOrderCreationConfig  = async (body) => {
    const response = await AxiosInstance.put(`/advanced/settings/?order_creation_config`,body);
    if (!response.data.error) {
      return response.data;
    } else {
       return Promise.reject(response.message);
     }
   };
